import { Outlet, createFileRoute } from "@tanstack/react-router";
import { RedirectToLogin } from "@/components/auth/redirect";
import { ShellSkeleton } from "@/components/shell/app-shell";
import { useAuthStatus } from "@/lib/use-auth-status";

export const Route = createFileRoute("/_app")({
  component: SignedInOnly,
});

/** Everything under here needs a session. Without one, sign in and come back. */
function SignedInOnly() {
  const status = useAuthStatus();
  if (status === "loading") return <ShellSkeleton />;
  if (status === "signedOut") return <RedirectToLogin />;
  return <Outlet />;
}
